export enum TableColType {
  Ago,
  Checkbox,
  Avatar,
  Badge,
  Button,
  Date,
  Link,
  ExternalLink,
  Number,
  Pills,
  Score,
  Status,
  Text,
  Order,
  Pictures,
  Array
}
